import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => {
  return {
    checkField: {
      textTransform: 'capitalize',
      marginBottom: '0 !important',
      padding: 0,
    },
    rangeError: {
      color: theme.palette.error.main,
    },
  };
});

export default useStyles;
